// utils/trpc.ts
import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@arc-connect/server';

export const trpc = createTRPCReact<AppRouter>();
export type TRPCClient = ReturnType<typeof trpc.useContext>['client'];
export type { AppRouter };
